<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Gestion du code barre de la boîte archive</strong>
          </div>
          <b-row>
            <b-col md="4">
              <b-form>
                <b-form-group label="Code barre" label-for="codeBarre">
                  <b-input-group prepend="#">
                  <b-form-input
                    id="codeBarre"
                    type="text"
                    autocomplete="name"
                    :class="{hasError: errors.codeBarre !== ''}"
                    v-model="codeBarre"
                    :formatter="formatterCodeBarre"
                  />
                </b-input-group>
                  <span class="field-error">{{ errors.codeBarre }}</span>
                  <span class="field-warning text-warning">L'enregistrement d'un code barre met automatiquement fin au précédent.</span>
                </b-form-group>
                <div class="mt-5" slot="footer">
                  <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-save"/> Enregistrer
                  </b-button>
                </div>
              </b-form>
            </b-col>
            <b-col md="8">
              <v-client-table :columns="columns" :data="data" :options="options">
                <div v-if="props.row.code_barre" slot="code_barre" slot-scope="props">{{ formatterCodeBarre(props.row.code_barre) }}</div>
                <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
                  <span class="badge badge-success p-2">{{ formatDateTime(props.row.created_at, '/') }}</span>
                </div>
                <div v-if="props.row.date_fin" slot="date_fin" slot-scope="props" class="slot-date">
                  <span class="badge badge-success p-2">{{ formatDateTime(props.row.date_fin, '/') }}</span>
                </div>
                <div v-if="props.row.gestionnaire" slot="gestionnaire" slot-scope="props">{{ props.row.gestionnaire.prenom }} {{ props.row.gestionnaire.nom }}</div>
              </v-client-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "AddCodeBarre",
    data() {
      return {
        formatDateTime,
        codeBarre: '',
        errors: {
          codeBarre: '',
        },
        columns: ['code_barre', 'created_at', 'date_fin', 'gestionnaire'],
        data: [],
        options: {
          headings: {
            'code_barre': 'Code barre',
            'created_at': 'Date de création',
            'date_fin': 'Date de fin',
            'gestionnaire': 'Gestionnaire'
          },
          columnsClasses: {
            code_barre: 'pre-formatted sort-top position-r',
            created_at : 'pre-formatted sort-top position-r col-xs',
            date_fin : 'col-xs',
          },
          sortable: ['code_barre', 'created_at'],
          filterable: ['code_barre'],
          texts: {
            filterPlaceholder: 'Code barre'
          },
          perPage: 10,
          perPageValues: [10, 25, 50],
          orderBy: {column: 'created_at', ascending: false},
        },
      }
    },
    created() {
      this.getCodeBarre();
    },
    methods: {
      save() {
        if (this.validateData()) {
          let self = this;
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.codeBarre = this.codeBarre;
          this.$axios
            .post("/espaceGestion/code-barre", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.codeBarre = '';
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "Le code barre a été bien enregistré ",
                showConfirmButton: false,
                timer: 5000
              });
              this.getCodeBarre()
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.handleError(error);
            });
        }
      },
      getCodeBarre() {
        let self = this;
        this.$axios
          .get("/espaceGestion/code-barre")
          .then(response => {
            this.data = response.data.codesBarres;
          })
          .catch((error) => {
            self.$store.commit("IS_LOADING", false);
            self.handleError(error);
          });
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (isEmpty(this.codeBarre)) {
          this.errors.codeBarre = "Le code barre est obligatoire";
          valid = false;
        }
        if (this.codeBarre.replaceAll(' ','').length !== 11) {
          this.errors.codeBarre = "Le code barre doit faire obligatoirement 11 caractères";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.codeBarre = "";
      },
      handleError(error) {
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        let type = 'error';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit d\'enregistrer un code barre';
        } else if (!isEmpty(error) && error.response && error.response.status === 424) {
          text = error.response.data.message;
          type = 'warning';
        }
        this.$swal({
          position: 'top',
          type: type,
          title: 'Attention !!',
          text: text,
          showConfirmButton: false,
          timer: 5000
        });
      },
      formatterCodeBarre(value) {
        // console.log('value avant',value)
        let cleanedValue = '';
        for (let i = 0; i <= value.length - 1; i++) {
          // console.log('value[i]',value[i])
          if(value[i] !== ' ') {
            cleanedValue = cleanedValue + value[i];
          }
        }
        // value = value.replaceAll(' ','');
        // console.log('value après',value)
        return cleanedValue.substring(0,3)+' '+cleanedValue.substring(3,9)+' '+cleanedValue.substring(9);
        // return value.substring(0,3)+' '+value.substring(3,9)+' '+value.substring(9);
      },
    }
  }
</script>
